import ReactSignatureCanvas from "react-signature-canvas";

function SignatureBox({ canvasRef, setSignatureIsEmpty }) {
  function handleClearSig(e) {
    e.preventDefault();
    canvasRef.current.clear();
    setSignatureIsEmpty(true);
  }

  return (
    <fieldset>
      <label>Release Authorization Signature</label>
      <ReactSignatureCanvas
        ref={canvasRef}
        penColor="black"
        canvasProps={{ width: 400, height: 120, "data-cy": "signature-canvas" }}
        onBegin={() => setSignatureIsEmpty(false)}
      />
      <div className="sign-agreement">
        By signing you agree to our{" "}
        <a href="/terms" target="_blank">
          terms and conditions
        </a>
        .
      </div>
      <div>
        <button className="button-secondary" onClick={handleClearSig}>
          Clear Signature
        </button>
      </div>
    </fieldset>
  );
}

export default SignatureBox;
